/**
 *
 * Priority2Badge
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import { COLORS } from '../../../../theme';
import Badge from '..';

const StyledBadge = styled(Badge)`
  &.MuiChip-root {
    color: ${COLORS.charcoalDark};
    background: ${COLORS.charcoalLight};
    border-color: ${COLORS.charcoal};
  }

  && .MuiSvgIcon-root {
    path {
      fill: ${COLORS.charcoal};
    }
  }
`;

function Priority2Badge(props) {
  return <StyledBadge label="2nd Priority" {...props} />;
}

export default memo(Priority2Badge);
